import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initTelemetry, TelemetryErrorBoundary, ReportProblem } from '@cca/ui';
import { App } from './App';
import { initTheme } from './lib/theme';
// Shared design system (tokens + canonical component classes) before the app
// stylesheet; finance keeps its own base/body + night-mode token overrides.
import '@cca/ui/tokens';
import '@cca/ui/components';
import './styles/globals.css';

initTheme(); // set light/dark before first paint — no flash

// Production telemetry (Phase 4): window errors, unhandled rejections, API and
// render failures. API_BASE-relative so it matches the api client's origin.
const apiBase = (import.meta.env.VITE_API_BASE as string | undefined) ?? '';
initTelemetry({ portal: 'finance', endpoint: `${apiBase}/api/telemetry` });

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element');

createRoot(root).render(
  <StrictMode>
    <TelemetryErrorBoundary>
      <App />
      <ReportProblem />
    </TelemetryErrorBoundary>
  </StrictMode>,
);
